import { LogicalOption } from './option.js';

const OptionableMixin = {
  components: {
    'logic-option': LogicalOption
  },

  data: function() {
    return {
      judgements: []
    };
  },

  computed: {
    composedOptions: function() {
      if (this.field.other_option) {
        return this.field.options.concat([{
          id: 0,
          value: this.field.other_option
        }]);
      } else {
        return this.field.options;
      }
    },

    valid: function() {
      return this.judgements.every((judgement) => judgement.valid);
    }
  },

  template: `
    <div class="form-field-input">
      <div class="options readonly logic-options">
        <logic-option v-for='option in composedOptions'
                      :option='option'
                      :logic='_getLogic(option)'
                      :key='option.id'
                      ref='options'
                      :controlableFields='controlableFields'
                      :possibleFields='possibleFields'
                      :logicable='logicable'
                      :icon='optionIcon'
                      @childAdded='addChildFunc'
                      @editingChanged='changeEditingStatus'
                      @updateSetting='updateLogicSetting' />
      </div>
    </div>
  `,

  methods: {
    clearInvalidLogic: function() {
      _.each(this.judgements, (judgement) => {
        judgement._removeInvalidLogic();
      });
    },

    updateLogicSetting: function(settings, option) {
      this.logicSettings = _.chain(this.judgements)
        .map((judgement) => {
          if (!judgement.fieldIds.length) {
            return;
          }
          return judgement.getLogicSetting();
        })
        .compact()
        .value();

      this.emitLogicSetting();
    },

    changeEditingStatus: function(new_status) {
      if (new_status) {
        this.editing = new_status;
      } else {
        this.editing = _.some(this.judgements, (judgement) => judgement.editing);
      }
    },

    addChildFunc: function(vm) {
      this.judgements.push(vm);
    },

    _getLogic: function(option) {
      return (_.find(this.logicSettings, (setting) => (_.first(setting.in)) === option.id)) || { type: 'inclusion', in: [option.id], field_ids: [] };
    }
  }
};

export { OptionableMixin };
